module.exports = __webpack_public_path__ + "static/media/StringsSample.db30e431.mp3";